import { isEmpty } from 'lodash'

const usersReducerDefaultState = {
  profileDialogOpen: false,
  createUserDialogOpen: false,
  editUser: {},
  updatingUser: false
}

export default (state = usersReducerDefaultState, action) => {
  switch (action.type) {
    case 'USER::UPDATING_USER':
      return {
        ...state,
        updatingUser: action.updatingUser
      }
    case 'USER::UPDATE':
      return {
        ...state,
        editUser: {
          ...state.editUser,
          ...action.updates
        }
      }
    case 'USER::SET':
      return {
        ...state,
        editUser: action.data
      }
    case 'USER::TOGGLE_PROFILE_DIALOG':
      return {
        ...state,
        profileDialogOpen: action.profileDialogOpen,
        editUser: action.editUser === undefined ? {} : action.editUser
      }

    case 'USER::RATING::SET':
      if (!isEmpty(state.editUser)) {
        let ratings = state.editUser.ratings
        if (action.rating.hasOwnProperty('id')) {
          ratings = ratings.map(r => {
            if (r.id === action.rating.id) {
              const newId = action.rating.newId
              delete action.rating.newId
              r = {
                ...r,
                ...action.rating,
                id: newId
              }
            }
            return r
          })
        } else {
          ratings = [...ratings, action.rating]
        }
        return {
          ...state,
          editUser: {
            ...state.editUser,
            ratings,
            avg_rating: action.avgRating
          }
        }
      } else {
        return {
          ...state
        }
      }
    case 'USER::TOGGLE_CREATE_USER_DIALOG':
      return {
        ...state,
        createUserDialogOpen: action.createUserDialogOpen,
        editUser:
          action.editUser === undefined ? state.editUser : action.editUser
      }

    default:
      return state
  }
}
